import { i18next } from '@/i18n'

export default {
  path: 'selection-vo/',
  name: 'selection-vo',
  meta: {
    auth: 'ROLE_USER',
    title: i18next.t('Sélection VO')
  },
  component: () =>
    import(/* webpackChunkName: "posts" */ '../pages/selectionVo/selectionVoPostsList.vue')
}
